
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/syncs",
      function () {
        return require("private-next-pages/customer-studio/syncs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/syncs"])
      });
    }
  